import AbstractRequestTask from "../../AbstractRequestTask";
import Device from "../../../../devices/device";
import DeviceStorage from '../../../../components/DeviceStorage/DeviceStorage';
import { DISABLE_MODAL_RETRIES } from '../../../RequestManagerConstants';
import settings from "../../../../devices/all/settings";

class IsLoggedInOttV6Task extends AbstractRequestTask {

  constructor(fromLogout = false) {
    super();
    this.fromLogout = fromLogout;
    this.version = 'v6';
  }

  getHeaders() {
    return {};
  }
  
  getParams() {
    const params = super.getParams();
    const user_id = DeviceStorage.getItem('user_id') || '';
    delete params.api_version;
    delete params.user_token;
    delete params.device_name;
    delete params.device_so;

    return {...params, user_id};
  }
  
  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getUrl() {
    const server = settings.use_mock_endpoint ? settings.mock.server : Device.getDevice().getConfig().akamai_mfwk;
    const endpoint = settings.use_mock_endpoint ? 'ClaroVideo/Isloggedin/1.0.0/user' : 'services/user'
    const path = 'ott/isloggedin';
    return `${server}/${endpoint}/${this.version}/${path}`;
  }

  isValid(data){
    if (!data.data || !data.data.user_token) {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default IsLoggedInOttV6Task;


// WEBPACK FOOTER //
// ./src/requests/tasks/user/v6/IsLoggedInOttV6Task.js